export function isMobile (navigator) {
  return /Mobi|Android/i.test(navigator.userAgent) || (/Macintosh/i.test(navigator.userAgent) && isTouch(navigator))
}

export function isTouch (navigator) {
  return navigator.maxTouchPoints && navigator.maxTouchPoints > 1
}
